export const RESERVED_AREA_LINK = 'https://areariservata.assonave.it';
